import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_DEFINITION } from './transaction-timer-active-volume-bar-chart.definition';
import { TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_MOCK_DATA } from './transaction-timer-active-volume-bar-chart.mock';

export const TransactionTimerActiveVolumeBarChart = (props: ChartRendererProps) => <BarChart {...props} />;

TransactionTimerActiveVolumeBarChart.definition = TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_DEFINITION;
TransactionTimerActiveVolumeBarChart.mockData = TRANSACTION_TIMER_ACTIVE_VOLUME_BAR_CHART_MOCK_DATA;
